import React from 'react';
import { arrayOf, element } from 'prop-types';

import useStyles from 'hooks/useStyles';
import { ReactComponent as TriangleBgImage } from 'assets/CourseHome/bg-triangle.svg';
// eslint-disable-next-line css-modules/no-unused-class
import styles from './Layout.scss';

function Layout({ children }) {
  useStyles(styles);

  return (
    <div className={styles.root}>
      <TriangleBgImage className={styles.leftTriangle} />
      <div className={styles.decoRect} />
      {children}
      <div className={styles.decoHollowCircle} />
    </div>
  );
}

Layout.propTypes = {
  children: arrayOf(element),
};

Layout.defaultProps = {
  children: null,
};

export default Layout;
